import styled from "styled-components";

export const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const StyledSelector = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  width: 100%;
  padding: 30px;
`;

export const StyledSelectorText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

export const StyledSelectorTitle = styled.div`
  display: flex;
`;

export const StyledAppsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

export const StyledAppItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  cursor: pointer;
`;

export const StyledAppIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: gainsboro;
  border: 1px solid darkgray;
  color: white;
  &:hover {
    background-color: lightgray;
  }
`;

export const StyledAppIcon = styled.img`
  width: 40px;
  height: 40px;
`;
